import { PopupOptionListModalProps } from "./types"
import React from "react"
import { Platform } from "~/ui/primitives"
import { MaskPopup } from "~components/mask-popup"
import Icon from "~widgets/icon"
import styled from '~/ui/styled'
import { MODAL_MAX_WIDTH } from "~ui/app-shell"

const PopupOptionList = styled.FlatList`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  border-radius: ${({ theme }) => theme.radii.sm};
  overflow: hidden;
`

const PopupOptionWrap = styled.TouchableOpacity<{ isLast: boolean }>`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space.md};
  border-bottom-width: ${({ isLast }) => (isLast ? 0 : 1)}px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.border};
`

const PopupOptionText = styled.Text`
  color: ${({ theme }) => theme.colors.text};
`

const MainOverlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  pointer-events: none;
`

const Backdrop = styled.button`
  position: absolute;
  inset: 0;
  border: none;
  padding: 0;
  margin: 0;
  background-color: rgba(0, 0, 0, 0.45);
  cursor: default;
  pointer-events: auto;
`

const Panel = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
  min-height: 0;
  pointer-events: none;
`

const OptionCard = styled.div`
  width: 80%;
  max-width: 360px;
  max-height: 70vh;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii.sm};
  pointer-events: auto;
  flex-shrink: 0;
`

const PopupOptionListModal: React.FC<PopupOptionListModalProps> = ({
  visible,
  setVisible,
  options,
}) => {
  const visibleOptions = options.filter((item) => item.visible !== false)

  const renderPopupOtion = ({ item, isLast }) => {
    const { text, icon, onClick } = item
    return (
      <PopupOptionWrap onClick={onClick} isLast={isLast}>
        <PopupOptionText>{text}</PopupOptionText>
        {icon && <Icon {...icon}></Icon>}
      </PopupOptionWrap>
    )
  }

  const list = (
    <PopupOptionList
      showsVerticalScrollIndicator={false}
      data={visibleOptions}
      keyExtractor={({ text }) => text}
      renderItem={({ item, index }) =>
        renderPopupOtion({ item, isLast: visibleOptions.length - 1 === index })
      }
    />
  )

  if (Platform.OS === "web") {
    if (!visible) return null
    return (
      <MainOverlay>
        <Backdrop type="button" aria-label="关闭" onClick={() => setVisible(false)} />
        <Panel>
          <OptionCard>{list}</OptionCard>
        </Panel>
      </MainOverlay>
    )
  }

  return (
    <MaskPopup visible={visible} setVisible={setVisible}>
      {list}
    </MaskPopup>
  )
}

export default PopupOptionListModal
